import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { Instagram, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-900 bg-white"
    >
      <div className="grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] border-b border-zinc-900">
        <div className="p-8 md:p-10">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF1111]">
            {SITE.name}
          </p>
          <h4 className="font-display text-4xl md:text-5xl uppercase mt-3 leading-[0.9]">
            Built for the scroll.
            <br />
            Ready for the launch.
          </h4>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="mt-6 inline-flex items-center gap-2 bg-black text-white px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#FF1111] transition-all duration-200"
          >
            Start a brief <span aria-hidden="true">→</span>
          </Link>
        </div>

        <div className="p-8 md:p-10 flex flex-col gap-8 border-t md:border-t-0 md:border-l border-zinc-900">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Navigate</p>
            <div className="mt-3 flex flex-wrap gap-4 font-mono text-sm uppercase tracking-[0.15em]">
              <Link to="/" className="link-slash hover:text-[#FF1111]">Home</Link>
              <Link to="/work" className="link-slash hover:text-[#FF1111]">Work</Link>
              <Link to="/about" className="link-slash hover:text-[#FF1111]">About</Link>
              <Link to="/contact" className="link-slash hover:text-[#FF1111]">Contact</Link>
            </div>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Social</p>
            <div className="mt-3 flex flex-wrap gap-4 font-mono text-sm">
              <a href={SITE.instagramUrl} target="_blank" rel="noreferrer" className="link-slash flex items-center gap-2 hover:text-[#FF1111]">
                <Instagram size={14} /> @{SITE.instagram}
              </a>
              <a href={`tel:${SITE.phone}`} className="link-slash flex items-center gap-2 hover:text-[#FF1111]">
                <Phone size={14} /> {SITE.phoneDisplay}
              </a>
              <a href={`mailto:${SITE.email}`} className="link-slash flex items-center gap-2 hover:text-[#FF1111]">
                <Mail size={14} /> {SITE.email}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="px-5 md:px-8 py-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
        <span>© {new Date().getFullYear()} {SITE.name}. All heat reserved.</span>
        <span className="break-all">Pune • {SITE.email}</span>
      </div>
    </footer>
  );
}
